<template>
  <div class="flex-al-center flex-jc-start">
    <div style="width: auto">
      <div v-if="dwtType === 'select'" class="flex-jc-start">
        <div style="width: 120px; margin-right: 6px">
          <SpSelect v-model="cargoOrders.dwtRequirement.vesselTypes" checked-icon="triangle" multi-select
                    class="disable-no-normal font-10-select" :height="16" :width="124" type="bottomBorder2" select-icon-color="#EEB336"
                    :text-style="{fontSize: '10px', textAlign: 'left', paddingRight: '2px', textIndent: '2px', color: '#000000'}"
                    :need-search="false"
                    strategy="fixed" @change="(value,labels) => cargoOrders.dwtRequirement.vesselTypesLables = labels">
            <SpSelectOption v-for="code in tonnageCodeLabel" :value="code" :label="code" />
          </SpSelect>
        </div>
        <SpButton type="warn" height="16" width="75" circle-radius="3" @click="showCode = true">
          <span class="font10">Tonnage code</span>
        </SpButton>
      </div>
      <div v-if="dwtType === 'kMt'" class="flex-jc-start">
        <div style="width: 126px">
          <SpInput v-model="cargoOrders.dwtRequirement.kiloMin" :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '4px'}"
                   :precision="0" text-type="number" :min="1" :max="999"
                   :height="16" type="bottomBorder2" width="36" />K
          <span class="zhijian" />
          <SpInput v-model="cargoOrders.dwtRequirement.kiloMax" :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '4px'}"
                   :precision="0" text-type="number" :min="1" :max="999"
                   :height="16" type="bottomBorder2" width="36" />K
          &nbsp;MT
        </div>
      </div>
      <div v-if="dwtType === 'mt'" class="flex-jc-start">
        <div style="width: 162px;">
          <SpInput v-model="cargoOrders.dwtRequirement.dwtMin" :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '4px'}"
                   :precision="0" text-type="number" :min="1" :max="999999"
                   height="16" type="bottomBorder2" width="60" />
          <span class="zhijian" />
          <SpInput v-model="cargoOrders.dwtRequirement.dwtMax" :text-style="{fontSize: '10px', textAlign: 'center', paddingRight: '4px'}"
                   :precision="0" text-type="number" :min="1" :max="999999"
                   :height="16" type="bottomBorder2" width="60" />
          &nbsp;MT
        </div>
      </div>
    </div>
    <div style="width: 20px">
      <el-popover ref="typePopoverRef"
                  placement="bottom" popper-class="cus-no-pd-popover"
                  :width="254"
                  trigger="click">
        <template #reference>
          <div style="width: 20px;height: 17px; text-align: center">
            <span style="font-size: 6px; position:relative; top: 3px; color:#EEB336;" class="icon-triangle iconfont" />
          </div>
        </template>
        <div class="font10">
          <div class="select-item" :class="{'active-select-item': dwtType === 'select'}"
               @click="changeType('select')">
            <div class="input-line" style="width: 130px" />
            <span class="icon-triangle iconfont" style="margin-right: 8px; margin-left: 8px" />
            <span class="btn">Tonnage code</span>
          </div>
          <div class="pd-l-20 select-item" :class="{'active-select-item': dwtType === 'kMt'}"
               @click="changeType('kMt')">
            <div class="input-line" style="width: 32px; margin-left: 20px" />
            K <span style="margin-left: 2px; margin-right: 4px">-</span>
            <div class="input-line" style="width: 32px" /> K
            <span style="margin-left: 18px">MT</span>
          </div>
          <div class="select-item"
               :class="{'active-select-item': dwtType === 'mt'}"
               @click="changeType('mt')">
            <div class="input-line" style="width: 60px" />
            <span style="margin-left: 4px; margin-right: 4px">-</span>
            <div class="input-line" style="width: 60px" />
            <span style="margin-left: 4px">MT</span>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
  <TonnageCode :visible="showCode" :tonnage-code="tonnageCode" @close="showCode = false" />
</template>

<script>
import { computed, ref, watch } from 'vue'
import SpButton from '@/components/common/SpButton'
import SpSelect from '@/components/common/SpSelect.vue'
import SpSelectOption from '@/components/common/SpSelectOption.vue'
import SpInput from '@/components/common/SpInput'
import TonnageCode from './TonnageCode'
import { getMarineBallastRulesAllApi } from '../../../../request/APIs/common'
import _forEach from 'lodash/forEach'

export default {
  name: 'DwtSelect',
  components: { TonnageCode, SpButton, SpInput, SpSelectOption, SpSelect },
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    },

    cargoIndex: {
      type: Number,
      default: null
    },

    isCorrect: {
      type: String,
      default: ''
    },

    defaultType: {
      type: String,
      default: 'select'
    }
  },

  emits: ['update:modelValue'],
  setup (props, ctx) {
    const showCode = ref(false)
    const typePopoverRef = ref(null)
    const cargoOrders = computed({
      get () {
        return props.modelValue
      },
      set (nv) {
        ctx.emit('update:modelValue', nv)
      }
    })
    const dwtType = ref('select')
    watch(() => props.defaultType, () => {
      dwtType.value = props.defaultType
    })
    const changeType = (type) => {
      dwtType.value = type
      if (type === 'select') {
        cargoOrders.value.dwtRequirement.kiloMin = null
        cargoOrders.value.dwtRequirement.kiloMax = null

        cargoOrders.value.dwtRequirement.dwtMin = null
        cargoOrders.value.dwtRequirement.dwtMax = null
      }

      if (type === 'kMt') {
        cargoOrders.value.dwtRequirement.vesselTypes = null
        cargoOrders.value.dwtRequirement.vesselTypesLables = null

        cargoOrders.value.dwtRequirement.dwtMin = null
        cargoOrders.value.dwtRequirement.dwtMax = null
      }
      if (type === 'mt') {
        cargoOrders.value.dwtRequirement.vesselTypes = null
        cargoOrders.value.dwtRequirement.vesselTypesLables = null

        cargoOrders.value.dwtRequirement.kiloMin = null
        cargoOrders.value.dwtRequirement.kiloMax = null
      }

      typePopoverRef.value.hide()
    }
    const tonnageCode = ref()

    const tonnageCodeLabel = ref()

    getMarineBallastRulesAllApi().then(res => {
      const arr = []
      tonnageCode.value = res.data
      _forEach(res.data, (item) => {
        arr.push(...item.commonTitles)
      })

      tonnageCodeLabel.value = arr
    })
    return {
      typePopoverRef,
      cargoOrders,
      dwtType,
      showCode,
      changeType,
      tonnageCode,
      tonnageCodeLabel
    }
  }
}
</script>

<style scoped lang="less">
.zhijian{
  display: inline-block;
  width: 5px;
  border-top: 1px solid #000000;
  height: 3px;
  margin-left: 6px;
  margin-right: 4px;
}
.select-item {
  padding: 0 10px;
  .icon-triangle {
    position: relative;
    font-size: 8px;
    top: -2px;
  }

  .btn{
    display: inline-block;
    width: 77px;
    text-align: center;
    border-radius: 3px;
    height: 17px;
    line-height: 17px;
    background: #FCD88A;
    color: #000000;
  }
  cursor: pointer;
  height: 28px;
  &.active-select-item{
    background-color: #F7F7F7;
    color: #3A909D;
    .input-line {
      height: 16px;
      width: 76px;
      border-bottom: 1px solid #3A909D
    }
    .btn {
      color: #000000;
    }
  }
  .input-line {
    display: inline-block;
    height: 16px;
    width: 76px;
    border-bottom: 1px solid gray
  }
}
.select-item:hover {
  background-color: #F7F7F7;
  cursor: default;
  color: #3A909D;
  .input-line {
    border-bottom: 1px solid #3A909D
  }
}
</style>
